import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Button from "./button/button";

export default function NotFound() {
  return (
    <Stack
      alignItems={"center"}
      display={"flex"}
      height={"100vh"}
      justifyContent={"center"}
      padding={"2rem"}
      spacing={"2rem"}
      sx={{ backgroundColor: (theme: any) => theme.bg.paper }}
    >
      <Box>
        <img
          src={"/images/drivee-logo-white.svg"}
          alt="user profile"
          width={"200px"}
          loading="lazy"
        />
      </Box>
      <Typography align="center" fontWeight={700} gutterBottom variant="h5">
        Page not found!
      </Typography>
      <Button
        onClick={() => {
          // navigate("/");
          window.location.href = "/";
        }}
        color="primary"
        sx={{
          color: "white",
          fontSize: 12,
          fontStyle: "normal",
          fontWeight: 400,
        }}
        variant="contained"
      >
        Go to home page
      </Button>
    </Stack>
  );
}
